<template
  ><div>
    <div class="w-full">
      <div class="px-16 pt-16">
        <successSplitCrop
          :processData="processData"
          v-if="successProcess === 'split_and_crop'"
        />
        <successSplitCropSign
          v-else-if="successProcess === 'split_crop_and_sign'"
          :processData="processData"
          @cancel-publish="modalConfirmCancelPublish = true"
          @error-on-preview="
            (errorCode) => {
              $emit('error-on-preview', errorCode);
            }
          "
        />
        <upload
          v-else
          :processType="processType"
          :goToSchedulerList="goToSchedulerList"
          @updateLoading="uptLoading($event)"
        />
      </div>
      <div class="footer p-10 flex justify-end">
        <div class="">
          <zt-button
            class="cancel-button text-base font-bold"
            v-show="!goToSchedulerList"
            v-if="!loading"
            text
            @click="
              success
                ? (modalConfirmCancelPublish = true)
                : $emit('cancel-process')
            "
            >{{
              $t("message.publishDocuments.configMassivePublish.btnCancel")
            }}</zt-button
          >
          <zt-button
            class="text-base font-bold ml-2"
            :disabled="!validDownload || !success"
            @click="
              successProcess === 'split_and_crop'
                ? $emit('go-to-only-publish')
                : $emit('sign-and-publish', processData.tag)
            "
            >{{ $t(`message.publishDocuments.${processType}.next`) }}</zt-button
          >
        </div>
      </div>
    </div>
    <!-- MODAL PARA CONFIRMAR CANCELAR LA PUBLICACION -->
    <zt-modal
      :active="modalConfirmCancelPublish"
      @close="modalConfirmCancelPublish = false"
    >
      <template slot="modal-header">
        <div class="p-4 font-semibold text-zt-lg">
          <h4>
            {{ $t(`message.publishDocuments.${processType}.modalCancel.title`) }}
          </h4>
        </div>
      </template>
      <div class="w-full p-6 flex">
        <div class="w-11/12 mx-auto flex py-2">
          <div class="w-1/5 flex justify-center items-center mt-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              fill="none"
              viewBox="0 0 70 70"
            >
              <circle
                cx="35"
                cy="35"
                r="34"
                fill="#fff"
                stroke="#FB8C00"
                stroke-width="2"
              />
              <path
                fill="#FB8C00"
                stroke="#FB8C00"
                d="M34.654 42.776c-.94 0-1.713-.772-1.713-1.713v-18.85c0-.941.772-1.713 1.713-1.713.94 0 1.713.772 1.713 1.713v18.85c0 .944-.753 1.713-1.713 1.713zM34.654 48.203c.94 0 1.713.772 1.713 1.713 0 .94-.772 1.712-1.713 1.712-.94 0-1.713-.772-1.713-1.712 0-.941.772-1.713 1.713-1.713z"
              />
            </svg>
          </div>
          <div
            class="w-4/5 pt-2 pb-4 flex flex-wrap justify-start items-center px-4"
          >
            <span class="w-full text-zt-lg text-zt-dark-400 mt-8 font-normal">
              {{
                $t(`message.publishDocuments.${processType}.modalCancel.description`)
              }}
            </span>
          </div>
        </div>
      </div>
      <template slot="modal-footer">
        <div
          class="zt-modal-footer flex justify-end items-center p-4 bg-zt-dark-100"
        >
          <div class="w-1/4">
            <zt-button
              @click="modalConfirmCancelPublish = false"
              class="ml-1 button-cancel-only-text w-11/12 text-base"
            >
              {{ $t(`message.publishDocuments.${processType}.modalCancel.cancel`) }}
            </zt-button>
          </div>
          <div class="w-1/4">
            <zt-button @click="cancelPublish()" class="ml-1 w-11/12 text-base">
              {{ $t(`message.publishDocuments.${processType}.modalCancel.confirm`) }}
            </zt-button>
          </div>
        </div>
      </template>
    </zt-modal>
  </div>
</template>

<script>
import upload from "./splitAndCrop/upload";
import successSplitCropSign from "./splitAndCrop/successSplitCropSign";
import successSplitCrop from "./splitAndCrop/successSplitCrop";

export default {
  props: {
    status: {
      type: String,
      default: "",
    },
    processData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    upload,
    successSplitCropSign,
    successSplitCrop,
  },
  data() {
    return {
      loading: false,
      successProcess: "",
      downloading: false,
      modalConfirmCancelPublish: false,
    };
  },
  methods: {
    cancelPublish() {
      this.modalConfirmCancelPublish = false;
      this.$emit("cancel-publish", this.processData.tag);
    },
    uptLoading(loadingState) {
      this.loading = loadingState;
    },
  },
  computed: {
    validDownload() {
      return true;
    },
    processType() {
      return this.processData.type;
    },
    success() {
      return this.status === "processed";
    },
    processesLink() {
      this.$router.push('/company/process-manager');
    },
    goToSchedulerList() {
      return this.status === "new";
    },
  },
  created() {
    this.status === "processed"
      ? (this.successProcess = this.processType)
      : (this.successProcess = "");
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #eeeeee;
}
::v-deep .cancel-button {
  color: #575757 !important;
  background-color: transparent !important;
  font-weight: 500;
}

::v-deep .zt-button-disabled {
  color: #b6b6b6 !important;
}

.zt-button {
  font-weight: 500;
  box-shadow: none;
}

.button-cancel-only-text {
  background-color: #f5f5f5 !important;
  color: #949494 !important;
}
</style>
